import { CommonModule, CurrencyPipe } from "@angular/common";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { GoogleMapsModule } from "@angular/google-maps";
import { RouterModule } from "@angular/router";
import { TooltipModule } from "@cloudfactorydk/ng2-tooltip-directive";
import { IonicModule } from "@ionic/angular";
import { ComponentsModule } from "src/app/components/components.module";
import { DesktopHeaderComponentModule } from "src/app/shared/desktop-header/desktop-header.module";
import { PopupBeforePayModule } from "src/app/shared/popup-before-pay/popup-before-pay.module";
import { PromotionDialogModule } from "src/app/shared/promotion-dialog/promotion-dialog.module";
import { QtyStepperModule } from "src/app/shared/shop/qty-stepper/qty-stepper.module";
import { AddCouponComponent } from "../coupons/add-coupon/add-coupon.component";
import { BindingOptionsModule } from "../home-new/binding-options/binding-options.module";
import { HomeNewModule } from "../home-new/home-new.module";
import {
  NotebookPreviewComponent
} from "../shop/productos/product-custom-elements/previews/notebook-preview/notebook-preview.component";
import { ProductListModule } from "../shop/productos/product-list/product-list.module";
import { SocialAuthOptionsComponent } from "../social-auth-options/social-auth-options.component";
import { CartPreviewComponent } from "./cart-preview/cart-preview.component";
import {
  TooltipDefaultStandardShippingComponent
} from "./cart-preview/tooltip-default-standard-shipping/tooltip-default-standard-shipping.component";
import { ItemPrintProductComponent } from "./item-print-product/item-print-product.component";
import { ItemShopProductComponent } from "./item-shop-product/item-shop-product.component";

@NgModule({
  declarations: [
    ItemShopProductComponent,
    ItemPrintProductComponent,
    CartPreviewComponent,
    TooltipDefaultStandardShippingComponent,
    SocialAuthOptionsComponent,
    NotebookPreviewComponent
  ],
  exports: [
    ItemShopProductComponent,
    CartPreviewComponent,
    TooltipDefaultStandardShippingComponent,
    SocialAuthOptionsComponent,
    ItemPrintProductComponent,
    NotebookPreviewComponent
  ], imports: [CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    ComponentsModule,
    DesktopHeaderComponentModule,
    QtyStepperModule,
    PromotionDialogModule,
    PopupBeforePayModule,
    GoogleMapsModule,
    RouterModule,
    ProductListModule,
    TooltipModule,
    BindingOptionsModule,
    AddCouponComponent,
    HomeNewModule], providers: [CurrencyPipe, provideHttpClient(withInterceptorsFromDi())]
})
export class SharedComponentsModule {
}
